const auditList = {
    path: 'audit_list',
    component: resolve => require(['@/pages/admin/storage_audit/audit_list.vue'], resolve),
}

export default auditList